import { TableProps } from "./table.types";
import { Table, TableContainer } from "@mui/material";
import React from "react";
import TableHeader from "./TableHeader";
import TableBody from "./TableBody";

function TinyTable<T extends { [key: string]: any }>({
  headerCells,
  rows,
  rowsData,
  options,
  sx,
}: TableProps<T>) {
  const {
    currentSort,
    onSort,
    isSelectable,
    selectAllHandler,
    isAllSelected,
    isSelected,
    freezeEdgeColumns,
    selectHandler,
    showBorders,
    showActionAlways = false,
    ActionCTA,
    RowCTA,
    ActionColCTA,
  } = options;

  return (
    <TableContainer
      className="table-wrapper"
      sx={{
        borderRadius: 3,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      }}
    >
      <Table
        sx={[
          { backgroundColor: "common.white" },
          ...(Array.isArray(sx) ? sx : [sx]),
          showBorders && { borderCollapse: "separate" },
        ]}
      >
        <TableHeader
          currentSort={currentSort}
          headerCells={headerCells}
          isSelectable={isSelectable}
          selectAllHandler={selectAllHandler}
          isAllSelected={isAllSelected}
          onSort={onSort}
          ActionCTA={ActionCTA}
          ActionColCTA={ActionColCTA}
          showBorders={showBorders}
          freezeEdgeColumns={freezeEdgeColumns}
        />
        <TableBody
          headerData={headerCells}
          rows={rows}
          rowsData={rowsData}
          isSelectable={isSelectable}
          isAllSelected={isAllSelected}
          isSelected={isSelected}
          selectHandler={selectHandler}
          showActionAlways={showActionAlways}
          ActionCTA={ActionCTA}
          RowCTA={RowCTA}
          showBorders={showBorders}
          freezeEdgeColumns={freezeEdgeColumns}
        />
      </Table>
    </TableContainer>
  );
}

export default TinyTable;
